import PropTypes from 'prop-types';
import React from 'react';

import IconButton from './IconButton';

const MenuItem = ({styleName, onClick}) => (
  <div className="MenuItem">
    <IconButton
      styleName={`MenuItem--${styleName}`}
      onClick={onClick}
    />
  </div>
);

MenuItem.propTypes = {
  styleName: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/MenuItem.js